module.exports = ['$translate', 'AccountService', ($translate, AccountService) => (account, addTitle = true) => {
    // Eventually we could pass format and a dictionary of all account kinds

  if (account && account.first_name && account.last_name) {
    account.firstName = account.first_name;
    account.lastName = account.last_name;
  }

  if (account && account.firstName && account.lastName) {
    if (AccountService.isDoctor(account) && addTitle) {
      return `${$translate.instant('display_name.doctor')} ${account.firstName} ${account.lastName}`;
    }
    return `${account.firstName} ${account.lastName}`;
  }
  return '';
}];



// WEBPACK FOOTER //
// ./main/filters/display-name-filter.js